import { useEffect, useRef, useState } from 'react';
import { ensureFiltersLoaded, getProjects, getStatus, subscribe } from './store';
import { FilterProject, FiltersWsStatus } from './types';

interface UseFiltersProjectsOptions {
  requestIfEmpty?: boolean;
}

export const useFiltersProjects = (options: UseFiltersProjectsOptions = {}) => {
  const { requestIfEmpty = false } = options;
  const [projects, setProjects] = useState<FilterProject[]>(getProjects);
  const [status, setStatus] = useState<FiltersWsStatus>(getStatus);
  const wasRequestingRef = useRef(false);

  useEffect(() => {
    return subscribe((state) => {
      setProjects(state.projects);
      setStatus(state.status);
    });
  }, []);

  useEffect(() => {
    if (!requestIfEmpty) {
      wasRequestingRef.current = false;
      return;
    }

    const justOpened = !wasRequestingRef.current;
    wasRequestingRef.current = true;

    if (status === 'ready' || status === 'connecting') return;

    if (status === 'error') {
      if (justOpened) {
        ensureFiltersLoaded({ force: true });
      }
      return;
    }

    ensureFiltersLoaded();
  }, [requestIfEmpty, status]);

  const isLoading = requestIfEmpty && status !== 'ready' && status !== 'error';

  return { projects, status, isLoading };
};
